// Default progress values based on application status (domain-specific)
import { ApplicationStatus } from '@startus/applications';

export const STATUS_PROGRESS: Record<ApplicationStatus, number> = {
  [ApplicationStatus.NOT_STARTED]: 1,
  [ApplicationStatus.IN_PROGRESS]: 50,
  [ApplicationStatus.WAITING_RESPONSE]: 100,
  [ApplicationStatus.SENT]: 75,
  [ApplicationStatus.NOT_SELECTED]: 100,
};
